import { createFileRoute, redirect } from "@tanstack/react-router";
import {
  type EligibilityResponse,
  eligibilityQueryOptions,
} from "@/app/onboarding/api/get-eligibility";
import { shouldRedirectToOnboarding } from "@/app/onboarding/lib/selectors";
import { OrgProjectRouteError } from "@/lib/org-project-context/constants";
import { OrgProjectErrorFallback } from "@/lib/org-project-context/error-fallbacks";
import { resolveDashboardOrgProjectRoute } from "@/lib/org-project-context/hooks";

export const Route = createFileRoute("/_authenticated/")({
  beforeLoad: async ({ context }) => {
    const result = await resolveDashboardOrgProjectRoute(context.queryClient);

    if (result.outcome === "redirect") {
      let eligibility: EligibilityResponse;
      try {
        eligibility = await context.queryClient.ensureQueryData(
          eligibilityQueryOptions(result.organizationId, result.projectId)
        );
      } catch {
        throw redirect({
          to: "/orgs/$organizationId/projects/$projectId/playground/chat",
          params: {
            organizationId: result.organizationId,
            projectId: result.projectId,
          },
        });
      }

      const destination = shouldRedirectToOnboarding(eligibility);

      throw redirect({
        to:
          destination === "onboarding"
            ? "/orgs/$organizationId/projects/$projectId/onboarding"
            : "/orgs/$organizationId/projects/$projectId/playground/chat",
        params: {
          organizationId: result.organizationId,
          projectId: result.projectId,
        },
      });
    }

    throw new OrgProjectRouteError(result);
  },
  errorComponent: OrgProjectErrorFallback,
});
